import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import { FormLicenseType } from "./FormLicenseType";

export function NewLicenseType({ ...props }) {

   return (
      <CadastroContainer>
         <FormLicenseType />
      </CadastroContainer>
   );
}